import React from "react"
import PropTypes from "prop-types"

import { serviceShape, tqaShape } from "app/lib/shared_prop_types"

import "./header.scss"

const TQAHeader = ({ service, tqa, servicePath, serviceImg }) => (
  <section className="service-header">
    <div className="brand-section" styleName="brand-section">
      <a
        href={servicePath}
        title={service.name}
        target="_blank"
        rel="noreferrer"
        styleName="brand-link"
        data-track-ifttt-next-event="click"
        data-track-data={JSON.stringify({
          object_type: "service_link",
          object_id: service.name,
          location_type: "tqa_info",
        })}
      >
        <img
          styleName="small-service-logo"
          src={serviceImg}
          alt={service.name}
          title={service.name}
        />
        {service.name}
      </a>
      <h1>{tqa.name}</h1>
      <p>{tqa.description}</p>
    </div>
  </section>
)

TQAHeader.propTypes = {
  service: serviceShape.isRequired,
  tqa: tqaShape.isRequired,
  servicePath: PropTypes.string.isRequired,
  serviceImg: PropTypes.string.isRequired,
}

export default TQAHeader
